{
  "currency": "USD",
  "notes": "Entry prices for the /tools/software-stack-cost-calculator page. monthly = per-month price on monthly billing; annualMonthly = per-month price on annual billing; null = not published on the checked page (the calculator falls back to the other rate and flags yearly billing, or shows 'see site' when both are null). maxUsers = published seat cap for plan-fit matching (null = no published cap). perSeat = price multiplies by seat count.",
  "tools": [
    {
      "id": "honeybook",
      "name": "HoneyBook",
      "url": "https://www.honeybook.com/pricing",
      "perSeat": false,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Starter", "monthly": 36, "annualMonthly": 29, "maxUsers": null, "seatsNote": "flat subscription" },
        { "name": "Essentials", "monthly": 59, "annualMonthly": 49, "maxUsers": null, "seatsNote": "flat subscription" },
        { "name": "Premium", "monthly": 129, "annualMonthly": 109, "maxUsers": null, "seatsNote": "flat subscription; unlimited team members" }
      ]
    },
    {
      "id": "dubsado",
      "name": "Dubsado",
      "url": "https://www.dubsado.com/pricing",
      "perSeat": false,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Starter", "monthly": 35, "annualMonthly": null, "maxUsers": null, "seatsNote": "flat subscription" },
        { "name": "Premier", "monthly": 55, "annualMonthly": null, "maxUsers": null, "seatsNote": "flat subscription" }
      ]
    },
    {
      "id": "bonsai",
      "name": "Bonsai",
      "url": "https://www.hellobonsai.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Basic", "monthly": 15, "annualMonthly": 9, "maxUsers": null, "seatsNote": "per seat" },
        { "name": "Essentials", "monthly": 25, "annualMonthly": 19, "maxUsers": null, "seatsNote": "per seat" },
        { "name": "Premium", "monthly": 39, "annualMonthly": 29, "maxUsers": null, "seatsNote": "per seat" },
        { "name": "Elite", "monthly": 59, "annualMonthly": 49, "maxUsers": null, "seatsNote": "per seat" }
      ]
    },
    {
      "id": "quickbooks",
      "name": "QuickBooks Online",
      "url": "https://quickbooks.intuit.com/pricing/",
      "perSeat": false,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Simple Start", "monthly": 38, "annualMonthly": null, "maxUsers": 1, "seatsNote": "flat subscription; 1 user" },
        { "name": "Essentials", "monthly": 85, "annualMonthly": null, "maxUsers": 3, "seatsNote": "flat subscription; up to 3 users" },
        { "name": "Plus", "monthly": 140, "annualMonthly": null, "maxUsers": 5, "seatsNote": "flat subscription; up to 5 users" },
        { "name": "Advanced", "monthly": 340, "annualMonthly": null, "maxUsers": 25, "seatsNote": "flat subscription; up to 25 users" }
      ]
    },
    {
      "id": "hubspot",
      "name": "HubSpot",
      "url": "https://www.hubspot.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Free Tools", "monthly": 0, "annualMonthly": 0, "maxUsers": null, "seatsNote": "free CRM" },
        { "name": "Starter", "monthly": 20, "annualMonthly": 20, "maxUsers": null, "seatsNote": "per seat; list price on both billing views (a limited-time new-customer offer shows less)" }
      ]
    },
    {
      "id": "quo",
      "name": "Quo (OpenPhone)",
      "url": "https://www.quo.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Starter", "monthly": 19, "annualMonthly": 15, "maxUsers": null, "seatsNote": "per user; calling and messaging to US and Canada" },
        { "name": "Business", "monthly": 33, "annualMonthly": 23, "maxUsers": null, "seatsNote": "per user" },
        { "name": "Scale", "monthly": 47, "annualMonthly": 35, "maxUsers": null, "seatsNote": "per user" }
      ]
    },
    {
      "id": "google-voice",
      "name": "Google Voice",
      "url": "https://workspace.google.com/products/voice/",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Starter", "monthly": 10, "annualMonthly": null, "maxUsers": 10, "seatsNote": "per user; also needs a paid Google Workspace plan (not included)" },
        { "name": "Standard", "monthly": 20, "annualMonthly": null, "maxUsers": null, "seatsNote": "per user; also needs a paid Google Workspace plan (not included)" },
        { "name": "Premier", "monthly": 30, "annualMonthly": null, "maxUsers": null, "seatsNote": "per user; also needs a paid Google Workspace plan (not included)" }
      ]
    },
    {
      "id": "calendly",
      "name": "Calendly",
      "url": "https://calendly.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Free", "monthly": 0, "annualMonthly": 0, "maxUsers": 1, "seatsNote": "1 seat, 1 event type" },
        { "name": "Standard", "monthly": 12, "annualMonthly": 10, "maxUsers": null, "seatsNote": "per seat" },
        { "name": "Teams", "monthly": 20, "annualMonthly": 16, "maxUsers": null, "seatsNote": "per seat" }
      ]
    },
    {
      "id": "clickup",
      "name": "ClickUp",
      "url": "https://clickup.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Free Forever", "monthly": 0, "annualMonthly": 0, "maxUsers": null, "seatsNote": "60 MB storage" },
        { "name": "Core", "monthly": 12, "annualMonthly": 9, "maxUsers": null, "seatsNote": "per member" },
        { "name": "Business", "monthly": 25, "annualMonthly": 17, "maxUsers": null, "seatsNote": "per member" }
      ]
    },
    {
      "id": "toggl",
      "name": "Toggl Track",
      "url": "https://toggl.com/track/pricing/",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Free", "monthly": 0, "annualMonthly": 0, "maxUsers": 3, "seatsNote": "up to 3 users" },
        { "name": "Starter", "monthly": 12, "annualMonthly": 9, "maxUsers": null, "seatsNote": "per user" },
        { "name": "Premium", "monthly": 24, "annualMonthly": 16, "maxUsers": null, "seatsNote": "per user" }
      ]
    },
    {
      "id": "harvest",
      "name": "Harvest",
      "url": "https://www.getharvest.com/pricing",
      "perSeat": true,
      "checkedOn": "2026-10-23",
      "plans": [
        { "name": "Free", "monthly": 0, "annualMonthly": 0, "maxUsers": 1, "seatsNote": "1 seat, 2 projects" },
        { "name": "Teams", "monthly": 11, "annualMonthly": 9, "maxUsers": null, "seatsNote": "per seat; usage fees can apply above plan allowances" }
      ]
    }
  ]
}
